import strings from "../lang/Localiz";
import React from "react";
import useStore from "../store";
import HudPrize from "./HudPrize";
import numberWithSpaces from "../utils/numberWithSpace";
import { useLocation } from "react-router-dom";

function HudMain() {
    const username = useStore(state => state.username);
    const energy = useStore(state => state.energy);
    const move = useStore(state => state.move);
    const modal_showStore = useStore(state => state.modal_showStore);
    const localtion = useLocation();
    if (username) return (
        <div className={"hud-main-top"}>
            <div className={"hud-main-left"}>
                <div className={"hud-general-row"}>
                    <div className={"hud-general-row-icon-user"}/>
                </div>
                <div className={"hud-general-row"}>
                    <div className={"hud-nickname"}>{username}</div>
                    <div className={"hud-move"}>{strings.move}: {move} </div>
                </div>

                <div className={"hud-general-row"}>
                    <div className={"hud-energy"}>
                        <span/> {numberWithSpaces(energy)}
                    </div>
                </div>
            </div>
            {localtion.pathname == "/game" &&
                <div className={"hud-main-right"}>
                    <HudPrize/>
                    <div onClick={modal_showStore} className={"hud-store-main"}>
                        <div className={"hud-store-main-icon"}/>
                        <div className={"hud-event"}/>
                        <div className={"hud-tooltip"}>
                        {strings.store.tooltip}
                        </div>
                    </div>
                </div>
            }
            
        </div>
    )
    return null
}


export default HudMain;
